import { useInvoiceCentralLayoutContext } from '@/enterprise/components/InvoiceCentral/InvoiceCentralLayout';
import { EligibleInvoicesView } from '@/enterprise/features/invoiceTables/eligible';
import useFeature from '@/lib/features';
import { useReporting } from '@/reporting';
import useDataDog from '@/reporting/DataDog';

/**
 * Invoice Central eligible tab — thin host over the shared playable-invoice view.
 * Filter-bar download (all / filtered SEA CSV) is owned by EligibleInvoicesView.
 */
const EligibleInvoices = () => {
  const { addAction } = useDataDog();
  const { trackEnterpriseEvent } = useReporting();
  const [invoiceApiMigrationEnabled] = useFeature('enterprise-ui_invoiceApiMigration');
  const {
    buyer,
    urlParams: { makerOrganizationUuid, currency },
  } = useInvoiceCentralLayoutContext();
  const { takerMarkets } = buyer;

  return (
    <EligibleInvoicesView
      key={`${makerOrganizationUuid}-${currency}`}
      source={{
        makerOrganizationUuid,
        makerOrganizationName: buyer.makerOrganizationName,
        currency,
        takerMarkets,
      }}
      controlsIntercomTarget="invoiceCentralInvoiceControls"
      actions={{
        enableFilterBarDownload: invoiceApiMigrationEnabled,
        onDownloadSubmitted: ({ scope }) => {
          trackEnterpriseEvent('invoice-central::download-invoices::submitted', {
            invoiceType: 'eligible',
            downloadScope: scope,
            takerMarketIds: takerMarkets.map((tm) => ({
              takerId: tm.takerDivisionId,
              marketId: tm.legacyMarketId,
            })),
          });
        },
        onSearch: () => {
          addAction('invoice-central::invoices-searched', {
            invoiceType: 'eligible',
            makerOrganizationUuid,
            currency,
          });
        },
        onSort: ({ sortKey, sortDirection }) => {
          addAction('invoice-central::sort::changed', {
            invoiceType: 'eligible',
            sortKey,
            sortDirection,
            makerOrganizationUuid,
            currency,
          });
        },
        onFiltersChange: ({ filterKeys }) => {
          addAction('invoice-central::filters::changed', {
            invoiceType: 'eligible',
            makerOrganizationUuid,
            currency,
            filters: filterKeys,
          });
        },
      }}
    />
  );
};

export default EligibleInvoices;
